import { combineReducers } from 'redux';

import assignUsers from './assignUsers/reducer';
import chargeLimit from './chargeLimit/reducer';
import enrollment from './enrollment/reducer';
import page from './page/reducer';
import servedItems from './servedItems/reducer';
import settings from './settings/reducer';
import siteDetails from './siteDetails/reducer';
import assignItems from './assignItems/reducer';

export default combineReducers({
  assignUsers,
  chargeLimit,
  enrollment,
  page,
  servedItems,
  settings,
  siteDetails,
  assignItems,
});



// WEBPACK FOOTER //
// ./src/pages/sitesetup/state/reducer.js